// Purpose: Expose vendor-scoped capture and access using the shared credential boundary.
// Dependencies: business_verification_invite; no browser storage.
// Behavior: Vendor credentials never authorize sponsors or another event/record.
import { captureBusinessVerificationInvite, getBusinessVerificationInvite } from "./business_verification_invite";

export const captureVendorVerificationInvite = () => captureBusinessVerificationInvite("vendor");
export const getVendorVerificationInvite = (eventslug, vendorId) => getBusinessVerificationInvite("vendor", eventslug, vendorId);
